import { AxiosInstance, AxiosRequestConfig } from "axios";
import Config from "../../../config";
import { IFlightPathApiResponse } from "./BaseApiModel";
import { IFilteredOptions, IFilteredRequest } from "./filteredApi/FilteredApiModel";

export interface IBaseOrganisationApiModel<T> {
  version: string;
  controller: string;
  http: AxiosInstance;
  url: string;

  getById: (organisationId: number, id: number, config?: AxiosRequestConfig) => Promise<IFlightPathApiResponse<T>>;

  getSynopses: (organisationId: number, config?: AxiosRequestConfig) => Promise<IFlightPathApiResponse<T[]>>;

  // findAll: (organisationId: number, config?: AxiosRequestConfig) => Promise<IFlightPathApiResponse<T[]>>;

  remove: (organisationId: number, id: number, config?: AxiosRequestConfig) => Promise<IFlightPathApiResponse<void>>;

  create: (organisationId: number, data: T, config?: AxiosRequestConfig) => Promise<IFlightPathApiResponse<T>>;

  update: (
    organisationId: number,
    id: number,
    data: T,
    config?: AxiosRequestConfig
  ) => Promise<IFlightPathApiResponse<T>>;
}

export abstract class BaseOrganisationApiModel<T> implements IBaseOrganisationApiModel<T> {
  version: string = Config.API.VERSION.__LATEST__;
  controller: string;
  http: AxiosInstance;
  url: string = `/api/${this.version}/organisations`;

  constructor(http: AxiosInstance, controller: string) {
    this.http = http;
    this.controller = controller;
  }

  getById = async (organisationId: number, id: number, config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/${this.controller}/${id}`;
    let res = await this.http.get(url, config);
    if (res && res.status === 200) {
      return res.data as IFlightPathApiResponse<T>;
    }
  };

  remove = async (organisationId: number, id: number, config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/${this.controller}/${id}`;
    let res = await this.http.delete(url, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  create = async (organisationId: number, data: T, config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/${this.controller}`;
    let res = await this.http.post(url, data, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  getSynopses = async (organisationId: number, config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/${this.controller}`;
    let res = await this.http.get(url, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  update = async (organisationId: number, id: number, data: T, config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/${this.controller}/${id}`;
    let res = await this.http.put(url, data, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  getRequestQuery = (filters: Partial<IFilteredOptions>): string => {
    let s: IFilteredRequest = {
      page: filters.page,
      pageSize: filters.pageSize,
      sorts: filters.sorts,
      filters: filters.filters
    };
    let params = "?";
    params += s.page ? `page=${s.page}&` : "";
    params += s.pageSize ? `pageSize=${s.pageSize}` : "";
    params += s.sorts ? "&sorts=" + s.sorts : "";
    params += s.filters ? "&filters=" + s.filters : "";
    return params.replace(/^\?&(.*)$/i, "?$1");
  };
}
